<template>
    <div class="page courseList">
        <div class="generalPagePaddingH">

            <!-- 广告图 -->
            <div class="marginT16">
                <bannerModule ref="bannerModule"/>
            </div>

            <div class="marginT8">
                <div class="tabModule">
                    <header class="moduleHeader" style="padding: 10px 0 4px;">
                        <div class="flexLayout lineHeight24r16">
                            <div class="tabOption flexItem color333 bold" :class="{active : currentTabIndex == 0}"
                                @click="selectTab('免费课程', 0)">
                                免费课程
                            </div>
                            <div class="tabOption flexItem color333 bold" :class="{active : currentTabIndex == 1}"
                                 @click="selectTab('畅销课程', 1)">
                                畅销课程
                            </div>
                            <div class="tabOption flexItem color333 bold" :class="{active : currentTabIndex == 2}"
                                 @click="selectTab('新品课程', 2)">
                                新品课程
                            </div>
                        </div>
                    </header>
                    <div class="body">
                        <div class="courseList">
                            <div class="courseItem marginB12 roundBorder8 white_bg hiddenOverflow" v-for="dataItem in dataList"
                                :key="dataItem.id" @click="view(dataItem)">
                                <div class="coverImageArea bgEEE hiddenOverflow" style="height: 140px;">
                                    <img class="fullSpace" :src="dataItem.coverImg" alt=""/>
                                </div>
                                <div class="titleArea paddingH12 paddingT8 font14r bold color333">{{dataItem.title}}</div>
                                <div class="paddingH12 paddingB8 alignCenter clearfix lineHeightOneAndAHalfTimes">
                                    <span class="floatL font12r colorCCC">已更新{{dataItem.sectionCount}}节</span>
<!--                                    <span class="font12r colorCCC inlineBlock">16小时xx分钟</span>-->
<!--                                    <span class="fr font12r colorFA585C bold" v-show="!dataItem.chargeMode">免费</span>-->

<!--                                    &lt;!&ndash; 现价 优惠价 &ndash;&gt;-->
<!--                                    <span class="fr colorFA585C bold" v-show="dataItem.chargeMode">-->
<!--                                        ￥{{new Number(dataItem.price).toFixed(2)}}-->
<!--                                    </span>-->
<!--                                    &lt;!&ndash; 原价 市场价 &ndash;&gt;-->
<!--                                    <span class="fr font12r colorCCC bold textDelete marginR8" style="line-height: 20px; margin-top: 4px;"-->
<!--                                          v-show="dataItem.chargeMode">-->
<!--                                        {{new Number(dataItem.marketPrice).toFixed(2)}}-->
<!--                                    </span>-->

                                    <span class="red" v-if="dataItem.chargeMode==0">免费</span>

                                    <!-- 收费 -->
                                    <template v-else>

                                        <!-- 会员课程 -->
                                        <template v-if="dataItem.isV">
                                            <!-- 会员课程已购买会员 -->
                                            <template v-if="userInstance && userInstance.isContentHasVipPrivilege('datum')">
                                                <span class="grey deleteLine font14r">原价￥{{dataItem.price}}</span>
                                                <span class="marginL8 red">免费</span>
                                            </template>

                                            <!-- 会员课程未购买会员 -->
                                            <template v-else="">
                                                <!-- VIP icon -->
                                                <span class=" marginL8 red">￥{{dataItem.price}}</span>
                                            </template>
                                        </template>

                                        <!-- 非会员课程 -->
                                        <template v-else="">
                                            <span class=" marginL8" v-if="dataItem.isPay">￥0.0</span><!-- 已购买 -->
                                            <span class=" marginL8 red" v-else>￥{{dataItem.price}}</span><!-- 未购买 -->
                                        </template>
                                    </template>

                                </div>
                            </div>

                            <div class="alignCenter paddingV8" v-show="status == 'loading'">
                                <i class="icon spinner-loader"></i>
                            </div>

                            <div class="paddingV16 alignCenter font14r colorCCC"
                                 v-show="status=='ready' && pagination.current == pagination.totalPage"
                                :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                                没有更多课程了
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '../../appConfig';

// data
import externalApp from '@data/externalApp';

// modules
import bannerModule from '@comp/bannerModule';

// utils
import consoleHelper from '@util/consoleHelper';
import numberHelper from '@util/numberHelper';
import appHelper from '@util/appHelper';
import userUtil from "@comp/shixunApp/userUtil";

// config
const config = {
    apiConfig : {
        list : {
            url : 'portal/courseVod/listForAudience',
            totalPagePath : 'data.totalPage',
            params : {
                limit : 3
            },
            dataColumnMapping : {
                sectionCount : 'liveCount'
            }
        }
    }
};

export default {
    name: "courseList",
    components : {bannerModule},
    extends : shixunPagePart,
    data () {
        return {
            currentTabIndex : 0,
            apiConfig : config.apiConfig,
            enableDataList : true,      // 开启 dataList 功能
            autoLoadDataList : appConfig.mode != 'demo',
            scrollToLoadNextPage : true,    // 无限拖动加载
            pageSize : 3,
            externalApp : externalApp,

            userData : null,
            userInstance : null,
        }
    },
    methods : {
        generateDemoData : function () {
            let list = [];
            for (let i=0; i<3; i++)
            {
                let tItem = {
                    id : i,
                    title : '园长“苦恼”，幼儿园之间到底在竞争什么',
                    coverImg : appHelper.getRandomCoverImage(),
                    sectionCount : 260,
                    duration : numberHelper.getRandomInteger(2 * 60 * 60),
                    chargeMode : numberHelper.getRandomInteger(2) > 1
                };
                tItem.durationText = moment(tItem.duration * 1000).format('HH小时mm分钟');
                list.push(tItem);
            }

            this.dataList = list;
        },
        selectTab : function(catName, index) {

            this.currentTabIndex = index;

            delete this.apiConfig.list.params.chargeMode;
            delete this.apiConfig.list.params.orderBy;
            delete this.apiConfig.list.params.asc;

            switch (catName) {
                case '免费课程' :
                    // chargeMode = FREE
                    this.apiConfig.list.params.chargeMode = 'FREE';
                    this.pageSize = 3;
                    break;
                case '畅销课程' :
                    // orderBy = HOT， asc = false
                    this.apiConfig.list.params.orderBy = 'HOT';
                    this.apiConfig.list.params.asc = false;
                    this.pageSize = 3;
                    break;
                case '新品课程' :
                    // orderBy = CREATE_TIME， asc = false
                    this.apiConfig.list.params.orderBy = 'CREATE_TIME';
                    this.apiConfig.list.params.asc = false;
                    this.pageSize = this.pagination.pageSize = 4;
                    break;
            }

            // this.apiConfig.list.params.categoryFirstId = catItem.id;
            this.reloadDataList();
        },
        view : function (item) {

            let url = '/learn/course/' + item.id;
            consoleHelper.log('go to: ' + url);
            location.href = url;
        }
    },
    mounted() {

        this.$refs.bannerModule.loadAd({
            typeEnum: 'HOME_KNOWLEDGE',
            limit: 8
        });

        appHelper.checkLogin((error, result) => {

            if (error)
            {
                return;
            }
            if (result)
            {
                this.userData = result;
                this.userInstance = userUtil.createUser(result);
            }
            else {
                this.setWechatShare();
            }
        });

    }
}
</script>

<style lang="scss" scoped>
.page {
    background:linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(250,250,250,1) 100%);
}
.tabModule {
    .moduleHeader {
        .tabOption {

            position: relative;
            padding-bottom: 6px;
            text-align: center;

            &:nth-child(n+2) {
                &:before {
                    display: block;
                    content : '';
                    width:1px;
                    height:16px;
                    background:rgba(238,238,238,1);

                    position: absolute;
                    z-index: 1;
                    left: 0;
                    top: 4px;
                }
            }

            &.active {
                color: #FA585C;
                &:after {
                    display: block;
                    content : '';
                    width:34px;
                    height:3px;
                    background:linear-gradient(270deg,rgba(250,84,94,1) 0%,rgba(249,129,69,1) 100%);
                    border-radius:2px;

                    position: absolute;
                    z-index: 2;
                    bottom: 0;
                    left: 50%;
                    margin-left: -17px;
                }
            }
        }
    }
}
.deleteLine {
    text-decoration: line-through;
}
</style>
